import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { AutenticacionService } from '../../services/autenticacion.service';
import { Maestros_SectorService } from '../../services/maestros_sector.service';
import { Maestros_ConsultasService } from 'src/app/services/maestros_consultas.service';
import { Maestros_ConsultasTiposService } from 'src/app/services/maestros_consultastipos.service';
import { Maestro_ConsultasTipos } from 'src/app/models/generic/Maestro_ConsultasTipos';
import { Maestros_GruposMenuService } from '../../services/maestros_gruposmenu';
import { Maestro_Grupos_Menu, TodoItemFlatNode, TodoItemNode } from 'src/app/models/generic/Maestro_Grupos_Menu';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'maestros-menu',
  templateUrl: './maestros-menu.component.html',
  styleUrls: ['./maestros-menu.component.scss']
})
export class MaestrosMenuComponent implements OnInit{
  
  form: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  
  flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();
  nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();
  selectedParent: TodoItemFlatNode | null = null;
  treeControl: FlatTreeControl<TodoItemFlatNode>;
  treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;
  dataSource: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;
  idSeleccionado: string = '';
  getLevel = (node: TodoItemFlatNode) => node.level;
  isExpandable = (node: TodoItemFlatNode) => node.expandable;
  getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;
  hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;
  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.item === '';
  transformer = (node: TodoItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = existingNode && existingNode.item === node.item
        ? existingNode
        : new TodoItemFlatNode();
    flatNode.id = node.id;
    flatNode.item = node.item;
    flatNode.level = level;
    if (this.utilitariosService.VerificarContieneDatosLista(node.children)) {
      flatNode.expandable = true;  
    } else {
      flatNode.expandable = false;
    }
    
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  }

  EstaSeleccionado(idRegistro: string): boolean {
    if (this.idSeleccionado === idRegistro) {
      return true;
    }
    return false;
  }

  CambiarSeleccionRegistro(idRegistro: string, seleccionado: any): void {
    if (seleccionado.checked) {
      if (this.idSeleccionado !== idRegistro) {
        this.idSeleccionado = idRegistro;
      }
    } else {
      this.idSeleccionado = '';
    }
    this.EstablecerValoresFormulario(idRegistro);
  }

  /* Get the parent node of a node */
  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_GruposMenuService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.ConsultarMenus();

    this.menuService.NotificarAccionBotonPrincipal.subscribe((accion: string) => {
      if (accion === 'check') {
        this.GuardarRegistro();
      }
    });
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      id: [0],
      idGrupo: [0],
      grupo: [''],
      idMenuPadre: [0],
      nombre: ['', [Validators.required, Validators.maxLength(100)]],
      componente: ['', [Validators.required, Validators.maxLength(100)]],
      orden: [0],
      icono: ['', [Validators.required]],
      activo: [false],
      requiereAliado: [false],
      requiereCanal: [false],
    });

    this.form.get('grupo').disable();
    this.form.get('nombre').disable();
    this.form.get('orden').disable();
    this.form.get('icono').disable();
  }

  GuardarRegistro() {
    if (this.form.valid) {
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      this.mostrarCargando = true;
      this.datosServices.Actualizar(this.form.value)
              .subscribe((resp: RespuestaGenerica) =>{
                this.mostrarCargando = false;
                if (resp.procesoExitoso == false) {
                  this.utilitariosService.MensajeToast(resp.mensaje);
                } else {
                  this.IniciarFormulario();
                  this.idSeleccionado = '';
                  this.ConsultarMenus();
                }
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
    }
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('MenuConfiguracionComponent');
  }
  ConsultarMenus() {
    this.mostrarCargando = true;
    let parametroConsulta = this.fb.group({
      filtro: ['']
    });
    this.datosServices.Consultar(parametroConsulta.value)
            .subscribe((resp: Maestro_Grupos_Menu[]) =>{
              this.datosServices.ListaMenus = resp;
              this.EstablecerValoresTreeView();
              this.mostrarCargando = false;
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  EstablecerValoresTreeView() {
    let listaDatosSeleccionar: TodoItemNode[] = [];
    if (this.utilitariosService.VerificarContieneDatos(this.datosServices.ListaMenus)) {
      for (let index = 0; index < this.datosServices.ListaMenus.length; index++) {
        if (this.utilitariosService.VerificarContieneDatosNumerico(this.datosServices.ListaMenus[index].idMenuPadre) === false) {
          let itemTreeView: TodoItemNode = new TodoItemNode();
          itemTreeView.id = this.datosServices.ListaMenus[index].id.toString();
          itemTreeView.item = this.datosServices.ListaMenus[index].nombre;
          itemTreeView.icon = this.datosServices.ListaMenus[index].icono;
          itemTreeView.children = [];
          this.EstablecerValoresTreeViewHijos(this.datosServices.ListaMenus[index].id.toString(), itemTreeView);
          listaDatosSeleccionar.push(itemTreeView);
        }
      }  
    }
    
    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataSource.data = listaDatosSeleccionar;
  }
  EstablecerValoresTreeViewHijos(id: string, itemTreeView: TodoItemNode) {
    for (let index = 0; index < this.datosServices.ListaMenus.length; index++) {
      if (this.datosServices.ListaMenus[index].idMenuPadre.toString() === id) {
        let itemTreeViewChild: TodoItemNode = new TodoItemNode();
        itemTreeViewChild.id = this.datosServices.ListaMenus[index].id.toString();
        itemTreeViewChild.item = this.datosServices.ListaMenus[index].nombre;
        itemTreeViewChild.icon = this.datosServices.ListaMenus[index].icono;
        itemTreeViewChild.children = [];
        this.EstablecerValoresTreeViewHijos(this.datosServices.ListaMenus[index].id.toString(), itemTreeViewChild);
        itemTreeView.children.push(itemTreeViewChild);
      }
    }
  }
  EstablecerValoresFormulario(idRegistro: string) {
    this.IniciarFormulario();
    if (this.EstaSeleccionado(idRegistro)) {
      let itemFiltro = this.datosServices.ListaMenus.filter(x => x.id.toString() === idRegistro)[0];
      this.form.setValue(itemFiltro);
      this.form.get('nombre').enable();
      this.form.get('orden').enable();
      this.form.get('icono').enable();
    }
  }
  TieneSeleccionado(): boolean {
    if (this.utilitariosService.VerificarContieneDatos(this.form)) {
      if (this.form.get('id').value > 0) {
        return true;
      }
    }
    return false;
  }
}
